// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { SearchProvider } from './contexts/SearchContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { SubrolesProvider } from './contexts/SubrolesContext';

import App from './App';
import './index.css';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

// Basename configurable: cambiar en config.js sin recompilar
// Basename configurable: cambiar en config.js sin recompilar
const basePath = (window.APP_CONFIG && window.APP_CONFIG.BASE_PATH !== undefined) ? window.APP_CONFIG.BASE_PATH : '/';

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <SubrolesProvider>
        <BrowserRouter
          basename={basePath}
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
          }}
        >
          <ToastProvider>
            <NotificationProvider>
              <SearchProvider>
                <SettingsProvider>
                  <App />
                </SettingsProvider>
              </SearchProvider>
            </NotificationProvider>
          </ToastProvider>
        </BrowserRouter>
        </SubrolesProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
